<template>
  <div>
    <!-- PROJECT TABLE -->
    <v-data-table
      v-model="selectedProjects"
      :headers="headers"
      :items="projects"
      :single-select="false"
      item-key="id"
      show-select
      class="elevation-1"
    >
      <!-- ***** HEAD ***** -->
      <template v-slot:top>
        <v-container class="fullwidth">
          <v-row>
            <v-col>
              <!-- filtro por status -->
              <strong class="d-flex flex-row">Buscar por status:</strong>
              <div id="filter-by-status" class="d-flex flex-row">
                  <div cols="1" class="item-status-filter" v-for="statusItem in statusFilterDetail" :key="statusItem.value">
                    <v-checkbox v-model="statusFilterInput" :value="statusItem.value"></v-checkbox>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="icon-filter-status"
                          v-bind="attrs"
                          v-on="on"
                          :color="statusItem ? statusItem.color : '#000'"
                        >
                          {{ statusItem ? statusItem.icon : '' }}
                        </v-icon>
                      </template>
                      <span>{{ statusItem.label }}</span>
                    </v-tooltip>
                  </div>
              </div>
              </v-col>

              <v-col>
                <!-- filtro nome empreendedor -->
                <strong class="d-flex flex-row">Buscar por empreendedor:</strong>
                <div class="d-flex flex-row">
                  <v-autocomplete
                    v-model="entrepreneurFilterInput"
                    :items="entrepreneurNames"
                    label="Digite/Selecione o nome"
                    variant="outlined" multiple outlined dense chips small-chips
                  ></v-autocomplete>
                </div> <!-- END filtro nome empreendedor -->
              </v-col>
          </v-row>
        </v-container>
      </template>
      <!-- END ***** HEAD ***** -->

      <!-- ***** CUSTOM COLUMNS ***** -->
      <!-- STATUS COLUMN -->
      <template v-slot:item.status="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, showStatusDescription }">
            <v-icon
              class="icon-filter-status"
              v-bind="showStatusDescription"
              v-on="on"
              :color=' (item.status && statusDetails[item.status]) ? statusDetails[item.status].color : "" '
            >{{ (item.status && statusDetails[item.status]) ? statusDetails[item.status].icon : "" }}</v-icon>
          </template>
          <span>{{ (item.status && statusDetails[item.status]) ? statusDetails[item.status].label : "-" }}</span>
        </v-tooltip>
      </template>
      <!-- END STATUS COLUMN -->

      <!-- ENTREPRENEUR COLUMN -->
      <template v-slot:item.entrepreneur="{ item }">
        {{ item.entrepreneur.name ? item.entrepreneur.name : '-' }}
      </template>
      <!-- END ENTREPRENEUR COLUMN -->

      <!-- ACTION COLUMN -->
      <template v-show="type === 'ACTION_TABLE'" v-slot:item.action="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :color="actionDetails.color"
              @click="onAction( item.id )"
            >{{ actionDetails.icon }}</v-icon>
          </template>
          <span>{{ actionDetails.label }}</span>
        </v-tooltip>
      </template>
      <!-- END ACTION COLUMN -->
      <!-- END ***** CUSTOM COLUMNS ***** -->
    </v-data-table>

    <!-- CARD FOOTER -->
    <v-card-actions v-if="btnText" v-show="btnText">
      <v-btn :color="buttonColor" type="buttom" @click="onClick">{{ btnText }}</v-btn>
    </v-card-actions>
    <!-- END CARD FOOTER -->

  </div>
</template>

<script>
import monitorStatusIcons from '@/const/project/monitorStatusIcons.js';
// import progress from '@/const/project/opportunityProgress.js';

export default {
  name: 'MonitorProjectTable',
  props: [
    "type", // (ACTION_TABLE|VOTING_SHOWCASE|VOTING_PORTAL) - To control columns
    'title', // String,
    'projects', // [],
    'tags', // must be null, monitor does not have tags
    'action', // String,
    'btnText', // String,
  ],
  data: () => ({
    selectedProjects: [], // Receives the checkbox-selected projects
    // ↓↓ Filters ↓↓
    // progressDetail: progress,
    progressFilterInput: [],
    statusFilterDetail: [], // status with icon included
    statusFilterInput: [],
    tagFilterInput: [],
    entrepreneurFilterInput: '',
    // ↓↓ custom columns ↓↓
    statusDetails: monitorStatusIcons,
    actionDetails: { color: null, label: null, icon: null },
    buttonColor: '',
  }),
  computed: {
    headers() {
      let h = [{
        text: "Status",
        align: "center",
        value: "status",
        filter: this.statusFilter,
      }, {
        text: "Tags",
        value: "tags",
        filter: this.tagFilter,
      }, {
        text: "Proposta",
        value: "nameOfProject",
      }, {
        text: "Empreendedor",
        value: "entrepreneur",
        filter: this.entrepreneurFilter
      }]

      if( !this.type )
        return h;
      
      if( this.type == 'ACTION_TABLE' ) {
        const actionColumn = { text: "", value: "action", };
        h.push( actionColumn );
      }else if( this.type == 'VOTING_PORTAL' ) {
        h.push( { text: "Votos", value: "totalVotes" } );
        h.push( { text: "Último voto", value: "lastDateVoteAt" } );
      } // if( type === 'VOTING_SHOWCASE' )
      return h;
    },
    entrepreneurNames() {
      if( !this.projects || this.projects.length === 0 )
        return [];
      const entrepreneurs = this.projects.map( project => project.entrepreneur ? project.entrepreneur.name : '' );
      return [...new Set( entrepreneurs )] // get unique names of entrepreneurs
    }
  },
  beforeMount() {
    this.statusFilterDetail
      = Object.keys( monitorStatusIcons ).map( (key) => {
        return monitorStatusIcons[key]
      });
  },
  mounted() {
    // Define actions and button color
    if( this.action === 'add' ) {
      this.actionDetails.color = 'success' ;
      this.actionDetails.label = 'Adicionar à votação' ;
      this.actionDetails.icon = 'add' ;
      this.buttonColor = 'success'
    } else if( this.action === 'remove' ) {
      this.actionDetails.color = 'red' ;
      this.actionDetails.label = 'Remover da votação' ;
      this.actionDetails.icon = 'clear' ;
      this.buttonColor = 'red'
    }
  },
  methods: {
    statusFilter( projectStatus ) {
      // TODO: Include progress
      if( !this.statusFilterInput || this.statusFilterInput.length === 0 )
        return true
      if( !projectStatus )
        return false
      if( this.statusFilterInput.includes( projectStatus ) )
        return true
      // if( this.statusFilterInput.includes( projectProgress ) )
      //   return true
      return false
    },
    entrepreneurFilter( projectEntrepreneur ) {
      if( !this.entrepreneurFilterInput || this.entrepreneurFilterInput.length === 0 )
        return true;
      if( !projectEntrepreneur || projectEntrepreneur.length === 0 || !projectEntrepreneur.name )
        return false; // It has a search sat, but project entrepreneur is empty

      return this.entrepreneurFilterInput.filter(
        entrepreneurFilterName => projectEntrepreneur.name === entrepreneurFilterName
      ).length > 0;
    },
    onClick() {
      const projectIds = this.selectedProjects.map( project => project.id );
      this.selectedProjects = [];
      this.$emit( 'btnClicked', projectIds );
    },
    onAction( projectId ) {
      this.$emit( 'triggerAction', [projectId] );
    }
  }
}
</script>


<style scoped>
  .fullwidth {
    max-width: 100%;
    width: 100%;
  }

  .nonothing {
    margin: 0 !important;
    padding: 0 !important;
  }

  .item-status-filter {
    display: flex;
    min-width: 70px;
    max-width: 60px;
    padding: 0;
  }

  .icon-filter-status {
    margin-top: -2px !important;
  }

  #filter-by-status {
    margin-top: -12px;
  }

  .v-data-table.elevation-1.theme--light {
      box-shadow: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/project/MonitorProjectTable.vue